/**
 * Delete Manufacturer Form Schema
 */

import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

const MIN_NUMBER = 1000000000
const MAX_NUMBER = 9999999999

export const DeleteManufacturerFormSchema = z.object({
  manufacturerNumber: z
    .number()
    .gte(MIN_NUMBER)
    .lte(MAX_NUMBER),
  manufacturerName: z
    .string()
    .min(1, 'Manufacturer name is required'),
})

export type DeleteManufacturerFormData = z.infer<typeof DeleteManufacturerFormSchema>

export function transformToApiRequest(formData: DeleteManufacturerFormData) {
  return {
    manufacturerNumber: formData.manufacturerNumber,
  }
}
